<script>
	import model from "../../stores/modelStore";
	import confirmationPages from "./confirmationPages";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";
	import { registerPageComplete } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import ConfirmationSectionHeader from "../../components/ConfirmationSectionHeader.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import Disclaimer from "./components/Disclaimer.svelte";

	export let pageName = null;
	export let pageTitle = null;
	export let nextPageLabel = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let disabled = true;
	let buttons = null;

	if ($model.lastPageVisited == "ThankYou") window.location.href = "/Registration";

	$model.lastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				$model.surveyComplete = true;

				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	let confirmed = false;
</script>

<PageSection>
	<Form id="form-confirmation-" on:submit={handleSubmit}>
		<FormRow class="justify-content-center">
			<FormColumn>
				<h1 class="text-center">{@html projectSettings.classActionName}</h1>
				<h2 class="text-center">Please confirm your details below to complete your registration</h2>
				<p>
					Please review the information you have provided and confirm the information is true and correct by
					clicking the checkbox below.
				</p>
			</FormColumn>
		</FormRow>

		<div class="confirmation">
			{#each confirmationPages as page}
				{#if (typeof page.hidePage === "function" && !page.hidePage($model)) || !page.hidePage}
					<ConfirmationSectionHeader heading={page.confirmationHeading} routeId={page.routeId}
					></ConfirmationSectionHeader>

					<svelte:component this={page.component} {disabled} />
				{/if}
			{/each}

			<Disclaimer />
		</div>

		<FormRow>
			<div class="col-md-8 col-sm-12">
				<Checkbox
					required="true"
					bind:checked={confirmed}
					label="I confirm that all information provided in this section is true and correct."
					id="confirmation"></Checkbox>
			</div>
		</FormRow>

		<div class="form-row mt-4">
			<div class="col-md-12 last">
				<NavigationButtons bind:buttons disableNext={!confirmed} {nextPageLabel}></NavigationButtons>
			</div>
		</div>
	</Form>
</PageSection>

<style>
	:global(.confirmation .confirmation-hide) {
		display: none;
	}

	:global(.confirmation-show) {
		display: none;
	}

	:global(.confirmation .confirmation-show) {
		display: flex;
	}

	:global(.confirmation .confirmation-show h1, .confirmation .confirmation-show h2) {
		margin-bottom: 16px;
	}

	:global(.confirmation .confirmation-box-shadow) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		box-shadow: var(--box-shadow-card);
		padding: 20px;
		margin-bottom: 26px;
	}

	:global(.confirmation input.form-control, .confirmation select.form-control) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		height: 44px;
		line-height: 18px;
		background-image: none;
	}

	:global(.confirmation textarea.form-control) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		background-image: none;
	}

	:global(.confirmation .row) {
		margin-top: 16px;
	}

	:global(.confirmation .datepicker .calendar-icon) {
		display: none;
	}
</style>
